<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 景点分类管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!--<el-button
                  type="primary"
                  icon="el-icon-delete"
                  class="handle-del mr10"
                  @click="delAllSelection"
                >批量删除
                </el-button>-->
                <el-select class="handle-select mr10 wd200" clearable placeholder="所属城市" v-model="search.menu">
                    <el-option :key="item.Id"
                               :label="item.Cname"
                               :value="item.Id"
                               v-for="item in sceOpt.city"></el-option>
                </el-select>
                <el-input class="handle-input mr10" clearable placeholder="景区分类名称" v-model="search.keyword"></el-input>
                <el-button @click="handleSearch" icon="el-icon-search" type="primary">搜索</el-button>
                <el-button @click="getScenicMenuData" icon="el-icon-refresh" type="warning">刷新</el-button>
            </div>
            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" sortable width="65"></el-table-column>
                <el-table-column label="景区分类名称" prop="Sname" sortable width="220"></el-table-column>
                <el-table-column label="上级编号" prop="Spid" sortable></el-table-column>
                <el-table-column label="所属城市" prop="cityName" sortable></el-table-column>
                <el-table-column align="center" label="Sflg" prop="Sflg"></el-table-column>
                <el-table-column align="center" label="Slevel" prop="Slevel"></el-table-column>
                <el-table-column align="center" label="排序编号" prop="Ssorder"></el-table-column>
                <el-table-column :filter-method="filterTag" :filters="[{ text: '屏蔽中', value: '0' }, { text: '正显示', value: '1' }]"
                                 align="center"
                                 label="景区状态"
                                 prop="Sstate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Sstate===0?'danger':(scope.row.Sstate===1?'success':'info')"
                        >{{scope.row.Sstate===0?'屏蔽中':(scope.row.Sstate===1?'正显示':'正推荐')}}
                        </el-tag>
                    </template>
                </el-table-column>

                <!--      <el-table-column sortable label="景点等级" align="center">
                        <template slot-scope="scope">
                          <el-tag>
                            {{scope.row.Sstar===0?'暂未评级':(scope.row.Sstar===1?'A':(scope.row.t===2?'AA':(scope.row.Sstar===3?'AAA':(scope.row.Sstar===4?'AAAA':'AAAAA'))))}}
                          </el-tag>
                        </template>
                      </el-table-column>-->
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <!--<el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>

            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :visible.sync="editVisible" title="编辑景点分类信息" width="30%">
            <el-form :model="form" label-width="70px" ref="form">
                <el-form-item label="分类名称">
                    <el-input class="wd200" v-model="form.Sname"></el-input>
                </el-form-item>
                <el-form-item label="分类拼音">
                    <el-input class="wd200" v-model="form.Schinese"></el-input>
                </el-form-item>
                <el-form-item label="分类排序">
                    <el-input class="wd200" v-model="form.Ssorder"></el-input>
                </el-form-item>
                <el-form-item label="所属地区">
                    <el-select placeholder="请选择" v-model="form.Scid">
                        <el-option :key="item.Id"
                                   :label="item.Cname"
                                   :value="item.Id"
                                   v-for="item in sceOpt.city"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分类状态">
                    <el-select placeholder="请选择" v-model="form.Sstate">
                        <el-option :value="0" label="屏蔽"></el-option>
                        <el-option :value="1" label="显示"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Slevel">
                    <el-select placeholder="请选择" v-model="form.Slevel">
                        <el-option :value="0" label="目的地"></el-option>
                        <el-option :value="1" label="分类"></el-option>
                        <el-option :value="2" label="景点"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Sflg">
                    <el-select placeholder="请选择" v-model="form.Sflg">
                        <el-option :value="0" label="分类"></el-option>
                        <el-option :value="1" label="景点"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Spid">
                    <el-input class="wd200" v-model="form.Spid"></el-input>
                </el-form-item>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                sceOpt: {
                    city: [],
                    free: {}
                },
                query: {
                    pageIndex: 1,
                    pageSize: 10
                },
                search: {
                    keyword: '',
                    menu: ''
                },
                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,
                addVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1
            };
        },
        created() {
            // this.reload();
            this.getScenicMenuData();
        },
        methods: {
            async getScenicMenuData() {
                const { data: res } = await this.$http.post('admin/partner/initScenicMenuData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点分类数据失败，请联系管理员!');
                }
                this.sceOpt.city = res.city;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal || 25;
                this.search.keyword = '';
                this.search.menu = '';
                this.show.page = true;
                this.show.search = false;
                this.$message.success('【景点分类数据】加载成功!');
            },
            // 触发搜索按钮
            async handleSearch() {
                const { data: res } = await this.$http.post('admin/partner/searchScenicMenu', {
                    search: this.search
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.sceOpt.city = res.city;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.show.page = false;
                this.show.search = true;
                this.$message.success('搜索成功，共有【 ' + res.pageTotal + ' 】符合条件的结果');
            },

            // 新增操作
            handleAdd() {
                this.addVisible = true;
            },

            // 编辑操作
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
            },

            // 保存编辑
            async saveEdit() {
                this.editVisible = false;
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/partner/addScenicMenu', {
                    form: this.form
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
                //  this.form=[];
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getScenicMenuData();
            },
            //标签筛选
            filterTag(value, row) {
                console.log('is runing' + value);
                return row.Sstate == value;
            }
        }
    };
</script>

<style scoped>

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
